import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { PageSection } from '@gik/ui-legacy/gik/PageSection';
import React from 'react';
import { useEnvStore } from '../store/EnvStore';
import bemBlock from '../utils/bemBlock';
import { ErrorPageSection } from './Error/ErrorPageSection';
import { SitemapSectionView } from './SitemapSectionView';

function SitemapComp() {
  const bem = bemBlock('sitemap');
  const rawBaseUrl = useEnvStore.getState().FRONTEND_BASE_URL || '/';
  const frontendBaseUrl = rawBaseUrl.endsWith('/') ? rawBaseUrl : rawBaseUrl + '/';

  const prefixes = {
    static: '',
  };

  const staticPages = [
    { url: 'terms-service', title: 'Terms of Service' },
    { url: 'privacy-policy', title: 'Privacy Policy' },
    { url: 'data-processing-agreement', title: 'Data Processing Agreement' },
    { url: 'create', title: 'Create' },
    { url: 'how-inkind-works', title: 'How InKind Works' },
    { url: 'features', title: 'Features' },
    { url: 'competitors', title: 'Competitors' },
    { url: 'faq', title: 'FAQ' },
    { url: 'about-us', title: 'About Us' },
    { url: 'contact', title: 'Contact' },
    { url: 'donate-gift-cards', title: 'Donate Gift Cards' },
    { url: 'set-up-meal-train', title: 'Set Up Meal Train' },
    { url: 'tips-sample-pages', title: 'Tips Sample Pages' },
    { url: 'share-updates', title: 'Share Updates' },
    //NOTE: changed from organize-gift-card-drive to flexible-gift-cards, see https://wolfellc.atlassian.net/browse/GIK-10023
    { url: 'flexible-gift-cards', title: 'Flexible Gift Cards' },
    { url: 'organize-care-group', title: 'Organize Care Group' },
    { url: 'free-fundraising', title: 'Free Fundraising' },
    { url: 'organize-donation-drive', title: 'Organize Donation Drive' },
    { url: 'give', title: 'Give' },
  ];

  return (
    <PageSection className={bem()}>
      <div className="tw-flex tw-flex-wrap">
        <SitemapSectionView
          baseUrl={frontendBaseUrl}
          title="Static Pages"
          items={staticPages}
          prefix={prefixes.static}
        />
      </div>
      <div>
        <h2>Other Sitemap Sections</h2>
        <a href={`${frontendBaseUrl}products/sitemap`}>Products</a>
        <br />
        <a href={`${frontendBaseUrl}inkinds/sitemap`}>Give InKind Pages</a>
        <br />
        <a href={`${frontendBaseUrl}give/sitemap`}>Give By</a>
        <br />
        <a href={`${frontendBaseUrl}articles/sitemap`}>Articles</a>
        <br />
      </div>
    </PageSection>
  );
}

export const SitemapPage = withComponentErrorBoundary(SitemapComp, {
  ErrorFallback: ErrorPageSection,
});
